<template>
  <div class="flex justify-between">
    <div class="flex flex-wrap">
      <div class="mr-6 tablet:w-64 w-full ">
        <h4 class="text-ellipsis">
          <span>{{ getTableName() }}</span>
          <small class="text-grey">
            - Arrival: {{ formattedArrivalTime() }} </small
          >

        </h4>
        <div>
          <p class="text-grey text-ellipsis">
            <small>
              <span v-if="section"> {{ section.name }}</span>
              <span v-if="section && enhancedBooking.booking.getThemeTag()"> - </span>
              
              <span class="tag-badge" v-if="enhancedBooking.booking.getThemeTag()">{{
                getBookingTagTranslation(enhancedBooking.booking.getThemeTag())
              }}</span>
            </small>
          </p>
        </div>
      </div>
      <div class="mr-6 tablet:w-64  w-full my-1">
        <p class="text-primary lh-1 text-ellipsis">
          {{
            enhancedBooking.bookingCustomer
              ? enhancedBooking.bookingCustomer.name
              : "No customer added"
          }}
          - {{ enhancedBooking.booking.guestCount }} pax
        </p>
        <p class="text-grey lh-1 text-ellipsis"><small>Guest</small></p>
      </div>
      <div class="mr-6 w-64 my-1">
        <p class="text-primary lh-1 text-ellipsis">
          {{ formatPrice(getTotalPrice(), getCurrency()) }} ({{
            getTotalQuantity()
          }}
          items)
          <span>
            <feather-icon
              v-if="enhancedBooking.booking.paymentReceived"
              :icon="'CheckIcon'"
              svgClasses="h-4 w-4 my-1"
            >
            </feather-icon
          ></span>
        </p>
        <p class="text-grey lh-1 text-ellipsis"><small>Pre orders</small></p>
      </div>

      <div class="mr-6 w-full tablet:w-64 xxl:w-full my-1">
        <p class="text-primary lh-1 text-ellipsis">
          <span
            class="mr-2"
            v-if="enhancedBooking.booking.isEnded()"
            :style="{
              color: BOOKING_TYPE_TAG.colorof(BOOKING_TYPE_TAG.Ended),
            }"
            >{{ getBookingTagTranslation(BOOKING_TYPE_TAG.Ended) }}</span
          >
          <span
            class="mr-2"
            :style="{
              color: BOOKING_STATE.colorof(
                enhancedBooking.booking.bookingState
              ),
            }"
            >{{
              BOOKING_STATE.nameof(enhancedBooking.booking.bookingState)
            }}</span
          >
          <span
            class="mr-2"
            v-if="enhancedBooking.booking.isAwaitingConfirmation()"
            :style="{
              color: BOOKING_TYPE_TAG.colorof(
                BOOKING_TYPE_TAG.AwaitsConfirmation
              ),
            }"
            >{{
              getBookingTagTranslation(BOOKING_TYPE_TAG.AwaitsConfirmation)
            }}</span
          >

          <span v-bind:class="getArrivalStateClass()"
            >| {{  ARRIVAL_STATE.nameof(enhancedBooking.booking.arrivalState) == "Arrived" && isPartialArrival ? "Partial Arrival" :  ARRIVAL_STATE.nameof(enhancedBooking.booking.arrivalState)  }}
          </span>
        </p>
        <p class="text-grey lh-1 text-ellipsis"><small>
          <span> Status </span>
          <span  v-if="enhancedBooking.booking.isWalkIn()"> - </span>
          <span :style="`color:${BOOKING_TYPE_TAG.colorof(BOOKING_TYPE_TAG.WalkIn)}`" v-if="enhancedBooking.booking.isWalkIn()">
            {{getBookingTagTranslation(BOOKING_TYPE_TAG.WalkIn)}}
          </span>

          </small></p>
      </div>
    </div>
    <div class="flex">
      <div
        v-if="showActions"
        class="my-auto mr-6"
        @click="
          $event.stopPropagation();
          $event.preventDefault();
        "
      >
        <booking-action-selector
          v-if="
            $AuthService.hasPermissionForActiveVenue(
              'vp.vp.booking.editbookings'
            )
          "
          @booking-action-selected="handleBookingActionSelected($event)"
        />
      </div>
      <div class="my-auto flex">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          v-if="enhancedBooking.booking.orderLines.length > 0"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
          />
        </svg>
        <feather-icon
          v-if="enhancedBooking.booking.paymentReceived"
          :icon="'CheckIcon'"
          class="payment-confirmed-icon"
          svgClasses="h-4 w-4 my-auto -ml-4"
        >
        </feather-icon>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          v-if="hasMessages()"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
          />
        </svg>
      </div>

      <div class="my-auto flex ml-4"></div>
    </div>
     <popup-on-arrival
      v-if="
        $AuthService.hasPermissionForActiveVenue(
          'vp.vp.booking.handleguestlistrequests'
        )
      "
      ref="PopupOnArrivalBooking"
      @update-guest-arrival-count="handlePartialGuestArrival"
      
    />
  </div>
  
</template>

<script>
import * as _ from "lodash";
import {
  BOOKING_STATE,
  ARRIVAL_STATE,
  BOOKING_TYPE_TAG,
} from "@/store/modules/marcom/data-model/bookings";
import { ACTIONS as VENUE_ACTIONS } from "@/store/modules/marcom/marcom";
import { ACTIONS as BOOKING_ACTIONS } from "@/store/modules/marcom/marcom-booking";
import { ChangeArrivalStateCommand } from "@/store/modules/marcom/data-model/bookings/queries-and-commands/change-arrival-state-command.js";
import BookingActionSelector from "./bookings/BookingActionSelector.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import PopupOnArrival from "../popups/PopupPartialArrivalBooking.vue";

export default {
  components: {
    BookingActionSelector,
    PopupOnArrival
  },
  props: {
    enhancedBooking: Object,
    showActions: Boolean,
  },
  data() {
    return {
      BOOKING_STATE,
      ARRIVAL_STATE,
      BOOKING_TYPE_TAG,
      section: null,
      THEME_OTHER: "THEME:OTHER",
    };
  },
  computed: {
    ...mapGetters({
      themeBookingTags: "marcom/themeBookingTags",
      getBookingTagTranslation: "marcom/getBookingTagTranslation",
    }),

    isPartialArrival(){
      if(this.enhancedBooking.booking.arrivals.length == 0) {return false}
      var arrived = 0
      this.enhancedBooking.booking.arrivals.forEach(arrival => {
          arrived += arrival.numPeopleArrived
      });
      return arrived != this.enhancedBooking.booking.guestCount

    },

    arrivalsCount(){
        if(this.enhancedBooking.booking.arrivals.length == 0) {return 0}
       var arrived = 0
      this.enhancedBooking.booking.arrivals.forEach(arrival => {
          arrived += arrival.numPeopleArrived
      });
      return arrived
    }
  },
  async mounted() {
    this.loadSection();
  },
  methods: {
    async handleBookingActionSelected(bookingAction) {
      try {

        if (bookingAction.name === "Partial arrival"){
       this.$refs.PopupOnArrivalBooking.show(this.enhancedBooking.booking);
          return
        }
        this.$vs.loading();

      
        if (bookingAction.type === "ARRIVAL_STATE") {
          const count = this.enhancedBooking.booking.guestCount - this.arrivalsCount
          if(bookingAction.name != "partial" && count != 0){
             const arrival = {numberOfGuests: count , note:""}
             await this.$store.dispatch("marcomBooking/" + BOOKING_ACTIONS.AddPartialArrival, 
                                                         {booking: this.enhancedBooking.booking, arrival: arrival})
          }
          const changeArrivalStateCommand = new ChangeArrivalStateCommand(
            this.enhancedBooking.booking,
            bookingAction.value
          );
          await this.$store.dispatch(
            "marcomBooking/" + BOOKING_ACTIONS.ChangeArrivalState,
            changeArrivalStateCommand
          );
        } else if (bookingAction.type === "BOOKING_TYPE_TAG") {
          const bookingTagCommand = {
            bookingTag: bookingAction.value,
            booking: this.enhancedBooking.booking,
          };
          await this.$store.dispatch(
            "marcomBooking/" + BOOKING_ACTIONS.ToggleBookingTag,
            bookingTagCommand
          );
        }
        this.$emit("booking-updated");

        this.$vs.notify({
          color: "success",
          title: "Booking status changed",
          text: "Booking status changed",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Booking status changed",
          text: "Oops, something went wrong",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    formattedArrivalDate() {
      return moment(this.enhancedBooking.booking.arrival).format(
        "DD/MM/YYYY HH:mm"
      );
    },
    formattedArrivalTime() {
      return moment(this.enhancedBooking.booking.arrival).format("HH:mm");
    },
    getTableName() {
      return this.enhancedBooking.reservedTable
        ? this.enhancedBooking.reservedTable.name
        : "No table";
    },

    async loadSection() {
      let section = await this.$store.dispatch(
        "marcom/" + VENUE_ACTIONS.GetVenueSection,
        {
          venueSetupId: this.enhancedBooking.booking.venueSetupId.id,
          venueSectionId: this.enhancedBooking.booking.venueSectionId.id,
        }
      );
      this.section = section;
    },
    getArrivalStateClass() {
      if (this.enhancedBooking.booking.arrivalState == ARRIVAL_STATE.Seated)
        return { "text-green": true, "text-opacity-70": true };
    },

    hasMessages() {
      return (
        this.hasCustomerMessage() ||
        (this.enhancedBooking.booking.bookingMessages &&
          this.enhancedBooking.booking.bookingMessages.length > 0)
      );
    },

    hasCustomerMessage() {
      return !!this.enhancedBooking.booking.customerMessage;
    },

    getTotalQuantity() {
      let tot = 0;
      for (const orderLine of this.enhancedBooking.booking.orderLines) {
        tot += orderLine.quantity;
      }
      return tot;
    },

    getOrderlineTotalPrice(orderLine) {
      return orderLine.quantity * orderLine.unitPrice.value;
    },

    getTotalPrice() {
      let tot = 0;
      for (const orderLine of this.enhancedBooking.booking.orderLines) {
        tot += this.getOrderlineTotalPrice(orderLine);
      }
      return tot / 100;
    },
    getCurrency() {
      let currency = undefined;
      for (
        let index = 0;
        index < this.enhancedBooking.booking.orderLines.length;
        index++
      ) {
        const orderLine = this.enhancedBooking.booking.orderLines[index];
        if (index === 0) currency = orderLine.unitPrice.currency;
        else {
          if (currency !== orderLine.unitPrice.currency) {
            currency = "MIXED!";
            break;
          }
        }
      }
      return currency;
    },

    formatPrice(decAmount, currency) {
      let options = {};
      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
      if (currency)
        _.assign(options, { style: "currency", currency: currency });
      let formatter = new Intl.NumberFormat("en-US", options);

      return formatter.format(decAmount); /* $2,500.00 */
    },
    // getThemeTagTranslation() {
    //   const themeTag = this.enhancedBooking.booking.getThemeTag();
    //   if (!themeTag) return undefined;

    //   let availableThemeTagsWithTranslations = this.themeBookingTags.filter(
    //     (twt) => twt.tag.indexOf("THEME:") >= 0
    //   );
    //   let themeTagWithTtranslation = availableThemeTagsWithTranslations.find(
    //     (twt) => twt.tag === themeTag
    //   );
    //   if (themeTagWithTtranslation)
    //     return themeTagWithTtranslation.translations.find(
    //       (t) => t.languageCode === "EN"
    //     ).translation;

    //   if (_.startsWith(_.toUpper(themeTag), `${this.THEME_OTHER}|`)) {
    //     return themeTag.substring(`${this.THEME_OTHER}|`.length);
    //   }

    //   return themeTag;
    // },
       async handlePartialGuestArrival({booking, arrival}){     
     try {
          this.$vs.loading();
     
          const action = {value: ARRIVAL_STATE.Arrived, type: "ARRIVAL_STATE", name: "partial"}
          if(booking.arrivalState !== action.value){
           this.handleBookingActionSelected(action)
           }
          arrival.arrivalId  ? await this.$store.dispatch("marcomBooking/" + BOOKING_ACTIONS.UpdatePartialArrival, 
          {booking: booking, arrival: arrival}) : await this.$store.dispatch("marcomBooking/" + BOOKING_ACTIONS.AddPartialArrival, 
          {booking: booking, arrival: arrival})
                  
          this.$emit("booking-updated");
       

          this.$vs.notify({
            color: "success",
            title: "Booking changed arrival count",
            text: "Booking partial arrival changed",
          });
        } catch (err) {
          console.error(err);

          this.$vs.notify({
            color: "danger",
            title: "Booking partiavl arrival",
            text: "Oops, something went wrong",
          });
        } finally {
          this.$vs.loading.close();
        }
    },
  },

 
};
</script>
<style scoped  lang="scss">
.payment-confirmed-icon svg {
  stroke: #00891b;
  background: #e2e2e2de;
  border-radius: 50%;
  padding: 2px;
}

.lh-1 {
  line-height: 1.3;
}

.text-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.text-red {
  color: #aa0000;
}
.text-green {
  color: #00891b;
}
.tag-badge {
  background: #e0e6eb;
  color: #464646;
  padding: 1px;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 4px;
}
.walkin-badge{
    color: #971d93;
}
</style>
